module.exports = __webpack_public_path__ + "static/media/grid.5fedef24.svg";